import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";

@Component({
  selector: 'app-reset-session-dialog',
  templateUrl: './reset-session-dialog.component.html',
  styleUrls: ['./reset-session-dialog.component.scss']
})
export class ResetSessionDialogComponent {
  @Input() selectedUser: number[] = []
  @Input() userName: string | undefined
  @Input() userId: number | undefined

  @Output() resetSessionEvent: EventEmitter<string> = new EventEmitter<string>()

  constructor(
    private modalService: ModalService
  ) {
  }

  closeModal() {
    this.modalService.closeModal()
  }

  resetSession() {
    let userIds: string
    if (this.selectedUser.length === 0 && this.userId) {
      userIds = this.userId.toString()
    } else {
      userIds = this.selectedUser.join(',')
    }
    this.resetSessionEvent.emit(userIds)
    this.closeModal()
  }
}
